<template>
    <div class="video-controls">
        <button @click="$emit('toggle-video')">
            <VideoPlayPause :paused="paused"></VideoPlayPause>
        </button>
        <button @click="$emit('end-meeting')">
            <EndMeeting></EndMeeting>
        </button>
        <button @click="$emit('toggle-audio')">
            <AudioPlayMute :muted="muted"></AudioPlayMute>
        </button>
        <span style="flex-grow: 1;"></span>
        <button @click="$emit('rotate-video')" v-if="!attendeePaused && callStatus === 'started'">
            <RotateVideo></RotateVideo>
        </button>
    </div>
</template>

<script>
import MeetingIcons from './icon'

export default {
    name: 'meeting-controls',

    props: {
        paused: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        attendeePaused: {
            type: Boolean,
            default: false
        },
        callStatus: {
            type: String,
            default: 'ready'
        }
    },

    components: {
        ...MeetingIcons
    }
}
</script>

<style lang="scss">
.video-controls {
    position: absolute;
    bottom: 0;
    height: 120px;
    width: 100%;
    display: flex;
    padding-left: 45px;
    padding-right: 38px;
    padding-bottom: 35px;
    z-index: 12;
    background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.7));
    & > button {
        background-color: transparent;
        border: none;
        width: 100px;
    }
}
</style>
